<template>
    <div id="drag-frame">
        <h1>{{$t("chatWindow.chooseAFileOrDragItHere")}}</h1>
    </div>
</template>

<script>
export default {
    name: "FileDragFrame",
};
</script>
<style lang="scss" scoped>
#drag-frame {
    width: 100%;
    height: 100%;
    background: white;
    background-image: linear-gradient(90deg, silver 50%, transparent 50%),
        linear-gradient(90deg, silver 50%, transparent 50%), linear-gradient(0deg, silver 50%, transparent 50%),
        linear-gradient(0deg, silver 50%, transparent 50%);
    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
    background-size: 15px 2px, 15px 2px, 2px 15px, 2px 15px;
    background-position: left top, right bottom, left bottom, right top;
    animation: border-dance 1s infinite linear;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
